<template>
  <div class="ui-content dashboard allindtest">
	  <div class="test-name-search cp3-test-name-search">
		 <div
			class="past-test-dropdown monitor-users-search cp3-monitor-users-search cp3-search-label"
			>
				<v-text-field
				class="search-box"
				@keydown="onSearch()"
				outlined
				label="Test Name"
				v-model="search"
				append-icon="mdi-magnify"
				/>
		</div>
   	</div>
    <div class="page-user user" v-if="tabsList && tabsList.length > 0">
      <v-tabs v-model="tab" background-color class="elevation-2 cust-tab">
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="tabData in tabsList"
          :key="tabData.id"
          :href="'#' + tabData.name"
          >{{ tabData.name }}</v-tab
        >
        <v-tabs-items :touchless="true" v-model="tab">
          <v-tab-item
            v-for="tabData in tabsList"
            :key="tabData.id"
            :value="tabData.name"
          >
            <v-card class="mx-auto normal-card">
              <TestList
                :parentId="TEST_TYPE.ALL_INDIA_TEST"
                :subType="tabData.id"
                :purchasedTest="tabData.purchasedTest"
				 :search="searchText"
              />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import TestList from "@/components/coordinator/Tests/TestList.vue";
import VueCookies from "vue-cookies";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "AllIndiaSeries",
  components: {
    TestList,
  },
  async mounted() {
    this.modules = JSON.parse(localStorage.getItem("modules"));
    await this.getModules()
    this.getSubTypes();
  },
  data() {
    return {
      tab: null,
      tabsList: [],
      modules: [],
	  searchText: "",
      search: "",
    };
  },
  computed: {
    ...mapState("userStore", ["user", "myInstitute"]),
  },
  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    ...mapActions({
      getUserPurchasedModules: "userStore/getUserPurchasedModules",
      getTestSubTypes: "utilStore/getTestSubTypes",
    }),

    getModules() {
      let userCookie = VueCookies.get("userDetails");
      let userId =
        this.user && this.user.id
          ? this.user.id
          : userCookie && userCookie.user && userCookie.user.id
          ? userCookie.user.id
          : null;

      const reqData = {
        userId: userId
      };
      return this.getUserPurchasedModules(reqData)
        .then((response) => {
          this.modules = response;
          localStorage.setItem("modules", JSON.stringify(this.modules));
          return response
        })
        .catch((err) => {
          console.log(err);
        });

    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.tab = crd.selectedTab ? crd.selectedTab : this.tabsList[0].name;
      }
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {};
        this.tabsList.map((t) => {
          tabDetail[t.name] = {
            page: 1,
            orderBy: {
              field: "test_name",
              order: "ASC",
            },
          };
        });
        let routeDetails = {
          routeName: rp.name,
          selectedTab: this.tab,
          tabDetails: tabDetail,
          searchText: "",
        };
        this.setRouteDetails(routeDetails);
      }
    },
    getSubTypes() {
      let postData = {
        main_types: [this.TEST_TYPE.ALL_INDIA_TEST],
      };
      this.$root.showLoader = true;
      this.getTestSubTypes(postData)
        .then((response) => {
          let tabDetail = [];
          response.map((subType) => {
            let type = subType;
            type.module = type.module.split(",").map((x) => parseInt(x));
            type.purchasedTest = false;
            for (let i = 0; i < this.modules.length; i++) {

              if (
                type.id &&
                type.module.includes(this.modules[i].module_id) &&
                this.modules[i].is_selected === 1
              ) {
                type.purchasedTest = true;
                tabDetail.push(type);
               
              }
            }
            // if (!type.purchasedTest) {
            //     tabDetail.push(type);   
            // }
          });
          tabDetail = tabDetail.filter(
            (v, i, a) => a.findIndex((t) => t.id === v.id) === i
          );

          this.tabsList = tabDetail;
          // this.$root.showLoader = false;
          this.defaultData();
          this.checkSessionData();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
	onSearch() {
		let routeName = this.$route.name;
		if (this.typetimeout) {
			clearTimeout(this.typetimeout);
		}
		// console.log(this.search);
		this.typetimeout = setTimeout(() => {
			this.searchText = this.search;
			let updatedDetails = { searchText: this.searchText };
			updatedDetails.routeName = routeName;
			this.setRouteDetails(updatedDetails);
		}, 1500);
	},
  },
  watch: {
    tab(val, oldVal) {
      if (oldVal) {
        // only when tab is changed and not on page load
        let routeName = this.$route.name;
        this.setRouteDetails({ routeName, selectedTab: val,searchText:"" });
		this.searchText = "";
		this.search = "";
      }
      this.addBreadCrumbChilde([
        {
          text: val,
          disabled: false,
        },
      ]);
    },
  },
};
</script>
